import { render, staticRenderFns } from "./ParecerAEEACPCadastro.vue?vue&type=template&id=69805632&"
import script from "./ParecerAEEACPCadastro.vue?vue&type=script&lang=js&"
export * from "./ParecerAEEACPCadastro.vue?vue&type=script&lang=js&"
import style0 from "./ParecerAEEACPCadastro.vue?vue&type=style&index=0&id=69805632&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports